export enum LOG_EXPORTER_API {
    EXPORT_ALL = "/api/log",
    EXPORT_SQL = "/api/TODO"
};